// extracted by mini-css-extract-plugin
export default {"ResultsFooter":"ResultsFooter_ResultsFooter__poSOm"};